import Axios from "../utils/axios";

export const login = async (params) => {
  return await Axios.post(`/api/member/Login`, params);
};

export const addMember = async (params) => {
  return await Axios.post(`/api/member/addmember`, params);
};

export const updatemember = async (params) => {
  return await Axios.post(`/api/member/updatemember`, params);
};

export const updateMember = async (params) => {
  return await Axios.post(`/api/member/updatemember`, params);
};

export const summary = async (params) => {
  return await Axios.post(`/api/member/summary`, params);
};
export const getSummaries = async (MemberID, FromDate, ToDate, offset, fetch) => {
  return await Axios.get(`/api/member/summary?MemberID=${MemberID}&fromDate=${FromDate}&toDate=${ToDate}&offset=${offset}&fetch=${fetch}`);
};

export const createAdjustmentRequest = async (params) => {
  return await Axios.post(`/api/member/request`, params);
};


export const uploadPdf = async (formData) => {
  return await Axios.post(`/api/member/reimbursement/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const createReimbursementRequest = async (params) => {
  return await Axios.post(`/api/member/reimbursement`, params);
};
export const getReimbursementRequest = async (memberId, fromDate, toDate, Status, RequestType, Offset, Fetch) => {
  return await Axios.get(`/api/member/reimbursement?memberId=${memberId}&FromDate=${fromDate}&ToDate=${toDate}&Status=${Status}&RequestType=${RequestType}&Offset=${Offset}&Fetch=${Fetch}`);
};
export const updateReimbursementStatus = async (params) => {
  return await Axios.post(`/api/member/reimbursementstatus`, params);
};
export const getPayrollRequests = async (MemberID, FromDate, ToDate, Status, RequestType, offset, fetch) => {
  return await Axios.get(`/api/member/request?MemberID=${MemberID}&FromDate=${FromDate}&ToDate=${ToDate}&Status=${Status}&RequestType=${RequestType}&Offset=${offset}&Fetch=${fetch}`);
};
export const updateRequestStatus = async (params) => {
  return await Axios.post(`/api/member/requeststatus`, params);
};
export const deleteRequest = async (Id) => {
  return await Axios.delete(`/api/member/request?Id=${Id}`);
};
export const getMembers = async (offset, fetch) => {
  return await Axios.get(`/api/member/members?offset=${offset}&fetch=${fetch}`);
};
export const updateBreak = async (params) => {
  return await Axios.post(`/api/Payroll/updatebreak`, params);
};
export const addbreak = async (params) => {
  return await Axios.post(`/api/Payroll/addbreak`, params);
};
export const deleteBreak = async (Id) => {
  return await Axios.delete(`/api/Payroll/deletebreak?Id=${Id}`);
};
export const getTimesheet = async (MemberID, FromDate, ToDate, offset, fetch) => {
  return await Axios.get(`/api/report/timesheet?MemberId=${MemberID}&FromDate=${FromDate}&ToDate=${ToDate}&Offset=${offset}&Fetch=${fetch}`);
};

export const getMemberMetric = async (MemberId) => {
  return await Axios.get(`/api/report/metrics?MemberId=${MemberId}`);
};
export const generateInvoice = async (params) => {
  return await Axios.post(`/api/report/makeinvoice`, params);
};

export const getMemberInvoices = async (MemberId, offset, fetch, month, year) => {
  const params = new URLSearchParams();
  if (MemberId !== undefined && MemberId !== null && MemberId !== "") {
    params.append("MemberId", MemberId);
  }
  if (month !== undefined && month !== null && month !== "") {
    params.append("month", month);
  }
  if (year !== undefined && year !== null && year !== "") {
    params.append("year", year);
  }
  params.append("offset", offset ?? 0);
  params.append("fetch", fetch ?? 100);
  return await Axios.get(`/api/report/member-invoices?${params.toString()}`);
};

export const updateInvoiceStatus = async (params) => {
  return await Axios.post(`/api/report/invoicestatus`, params);
};
export const generateBankPayrollReport = async (month) => {
  return await Axios.get(`/api/report/bankpayroll?month=${month}`);
};

export const getTaxSlabs = async () => {
  return await Axios.get(`/api/report/tax-slabs`);
};

export const updateTaxSlab = async (params) => {
  return await Axios.post(`/api/report/tax-slabs/update`, params);
};
export const getCurrentAttendance = async () => {
  return await Axios.get(`/api/payroll/currentattendance`);
};
export const checkIn = async () => {
  return await Axios.post(`/api/payroll/checkin`);
};
export const checkOut = async () => {
  return await Axios.post(`/api/payroll/checkOut`);
};
export const breakIn = async (params) => {
  return await Axios.post(`/api/payroll/breakIn`, params);
};
export const breakOut = async () => {
  return await Axios.post(`/api/payroll/breakOut`);
};
export const verifyBreak = async (params) => {
  return await Axios.post(`/api/payroll/breakverify`, params);
};
export const getMonitor = async (MemberId, fromDate, toDate, offset, fetch) => {
  return await Axios.get(`/api/monitor/monitor?MemberId=${MemberId}&fromDate=${fromDate}&toDate=${toDate}&offset=${offset}&fetch=${fetch}`);
};
export const createMonitor = async () => {
  return await Axios.post(`/api/monitor/monitor`);
};
export const getMember = async (MemberId) => {
  return await Axios.get(`/api/member/member?MemberId=${MemberId}`);
};

export const deleteAdjustmentRequest = async (Id) => {
  return await Axios.delete(`/api/member/deleterequest?Id=${Id}`);
};

export const getMemberReimbursementDetails = async (memberId) => {
  try {
    const response = await Axios.get(`/api/member/reimbursement-details?memberId=${memberId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching member reimbursement details:', error);
    throw error;
  }
};
